import { component as defineComponent } from 'flightjs';
import CarouselModel from 'contest/models/carousel-model';

const ATTRIBUTE_STEP = 'data-carousel-step';
const ATTRIBUTE_ACTIVE = 'data-carousel-active';
const CONTENT_ATTRIBUTE = 'data-carousel-content';

const heroCarousel = function () {
    this.attributes({
        stepElement: '[data-carousel-steps]',
        carouselElement: '[data-carousel-element]',
        attributeStep: '[data-carousel-step]',
        attributeActive: '[data-carousel-active]',
        contentAttribute: '[data-carousel-content]'
    });

    this.after ('initialize', function () {
        this.model = new CarouselModel({
            count: this.count(),
            goToStepCallback: this.goToStep.bind(this)
        });

        this.on('click', {
            attributeStep: this.captureStepClick
        });

        this.model.start();
    });

    this.count = function () {
        return this.select('stepElement').find(this.attr.attributeStep).length;
    };

    this.goToStep = function (stepIndex) {
        Array.from(this.select('stepElement').find(this.attr.attributeActive)).forEach(
            (step) => step.removeAttribute(ATTRIBUTE_ACTIVE)
        );

        Array.from(this.select('contentAttribute')).forEach(
            (step) => step.removeAttribute(ATTRIBUTE_ACTIVE)
        );

        this.node.setAttribute(ATTRIBUTE_STEP, stepIndex);
        if (this.currentStepElement(stepIndex)) {
            this.currentStepElement(stepIndex).setAttribute(ATTRIBUTE_ACTIVE, true);
        }

        if (this.currentContentElement(stepIndex)) {
            this.currentContentElement(stepIndex).setAttribute(ATTRIBUTE_ACTIVE, true);
        }
    };

    this.currentStepElement = function (index) {
        return this.select('stepElement')[0].querySelector(`[${ATTRIBUTE_STEP}="${index}"]`);
    };

    this.currentContentElement = function (index) {
        return this.node.querySelector(`[${CONTENT_ATTRIBUTE}][${ATTRIBUTE_STEP}="${index}"]`);
    };

    this.captureStepClick = function (event) {
        let stepElement = event.target;
        let stepElementIndex = Number(stepElement.getAttribute(ATTRIBUTE_STEP));

        if (stepElementIndex) {
            this.model.stop();
            this.model.goToStep(stepElementIndex);
        }
    };
};

export default defineComponent(heroCarousel);



// WEBPACK FOOTER //
// ./src/web/js/contest/ui/hero-carousel.js